import Dashboard from "views/Dashboard";
import {
  StarsIcon
} from "components/Icons/Icons";

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: <StarsIcon color="inherit" />,
    component: Dashboard,
    layout: "/admin",
  },
];
export default dashRoutes;
